/**
 * Contact form EmailJS configuration.
 * Add these values in .env:
 *   REACT_APP_EMAILJS_SERVICE_ID=service_xxxxxxx
 *   REACT_APP_EMAILJS_TEMPLATE_ID=template_xxxxxxx
 *   REACT_APP_EMAILJS_PUBLIC_KEY=xxxxxxxxxxxxxxxx
 */

/** Must match option values used in Contact.js */
export const SUBJECT_OPTIONS = [
  "Wholesale Order",
  "Product Sizing Query",
  "Custom Manufacturing",
  "Export Inquiry",
  "Other",
];

export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
export const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "";
